import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './Switcher.scss';
import classNames from 'classnames';

export default class Switcher extends Component {
    static propTypes = {
        checked: PropTypes.bool,
        onChange: PropTypes.func.isRequired
    };

    render() {
        const {checked} = this.props;

        const trackClassName = classNames(styles.switcherTrack, {
            [styles.switcherTrackChecked]: checked
        });

        const sliderClassName = classNames(styles.switcherSlider, {
            [styles.switcherSliderChecked]: checked
        });

        return (
            <div className={styles.switcher} onClick={this.handleChange}>
                <div className={trackClassName}></div>
                <div className={sliderClassName}></div>
            </div>
        );
    }

    handleChange = () => {
        const {checked, onChange} = this.props;
        onChange({
            target: {
                checked: !checked
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/Switcher.jsx